module.exports = "<svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\"><title>ic-close</title><path d=\"M6.314 5.076L1.983.746.745 1.982l4.331 4.33-4.33 4.332 1.237 1.237 4.33-4.33 4.332 4.33 1.237-1.237-4.33-4.331 4.33-4.331L10.645.745z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/icon/icons/close-thin.svg
// module id = 875
// module chunks = 0